import ClientStorage from '@naturehouse/nh-essentials/lib/storage/Storage';
import LocalStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/LocalStorageStrategy';
import type AbstractStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/AbstractStorageStrategy';

const STORAGE_KEY_SUFFIX = '-dismissed';

export default class NotificationBannerStorage {
    public static readonly DATABASE_NAME: string = 'AppPromotion';

    public async isDismissed(bannerId: string): Promise<boolean> {
        const storage = await this.#getStorage();

        return (await storage.getItem(this.#createStorageKey(bannerId))) === true;
    }

    public async markAsDismissed(bannerId: string): Promise<void> {
        const storage = await this.#getStorage();

        await storage.setItem(this.#createStorageKey(bannerId), true);
    }

    public async removeDismissalsExcept(bannerId: string): Promise<void> {
        const storage = await this.#getStorage();
        const activeStorageKey = this.#createStorageKey(bannerId);
        const obsoleteStorageKeys = (await storage.keys()).filter(
            (storageKey: string): boolean =>
                storageKey !== activeStorageKey && storageKey.endsWith(STORAGE_KEY_SUFFIX)
        );

        await Promise.all(
            obsoleteStorageKeys.map(
                async (storageKey: string): Promise<void> => storage.removeItem(storageKey)
            )
        );
    }

    #createStorageKey(bannerId: string): string {
        return `${bannerId}${STORAGE_KEY_SUFFIX}`;
    }

    async #getStorage(): Promise<AbstractStorageStrategy<boolean>> {
        return ClientStorage.retrieveStorage<boolean>(
            NotificationBannerStorage.DATABASE_NAME,
            LocalStorageStrategy
        );
    }
}
